import classNames from '@/utils/classNames';
import type { HTMLAttributes } from 'react';
import { forwardRef } from 'react';
import { CenteredPage } from './CenteredPage';
import styles from './CenteredPageContent.module.css';

interface CenteredPageContentProps extends HTMLAttributes<HTMLDivElement> {
    featured?: boolean;
}

/** For centering content in alignment with the page boundaries and spacing to the browser edge */
export const CenteredPageContent = forwardRef<HTMLDivElement, CenteredPageContentProps>(
    ({ className, featured, ...props }, ref) => {
        return (
            <CenteredPage
                ref={ref}
                className={classNames(styles.container, { [styles.featured]: featured }, className)}
                {...props}
            />
        );
    }
);
